var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Danh sách thiết bị đang đăng nhập",
        visible: _vm.dialogVisible,
        width: "800px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingData,
              expression: "loadingData",
            },
          ],
          ref: "multipleTable",
          attrs: {
            "empty-text": _vm.textTable,
            "element-loading-text": _vm.$tableLoading,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(255,255,255, 0)",
            data: _vm.dataTransfer,
            "highlight-current-row": "",
            "header-cell-style": _vm.$funcCommon.tableHeaderColorFunction,
            "max-height": _vm.$tableMaxHeight,
            border: "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              type: "index",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "idDevice", label: "idDevice" },
          }),
          _c("el-table-column", {
            attrs: { prop: "type", align: "center", label: "Loại thiết bị" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "type",
              align: "center",
              label: "Thời gian đăng nhập",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("formatDateTime")(scope.row.dateLogin))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "Tác vụ",
              width: "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "success" },
                        on: {
                          click: function ($event) {
                            return _vm.logoutMethod(scope.row)
                          },
                        },
                      },
                      [_vm._v("Đăng xuất")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }